// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"personal-plan-faq-skeleton_wrapper__5fTWE","row":"personal-plan-faq-skeleton_row__N5ehM","fill":"personal-plan-faq-skeleton_fill__tYdcG"};